<div class="complete-your-transfer-banner">
  <div class="complete-your-transfer-banner__illustration-wrapper">
    <img
      class="complete-your-transfer-banner__illustration"
      src="assets/images/inheritance-document-checklist/complete-your-transfer-illustration.png"
      alt=""
      data-cy="complete-transfer-illustration"
    />
  </div>
  <p
    class="c11n-text-lg-headline complete-your-transfer-banner__heading"
    data-cy="complete-transfer-heading"
  >
    {{ content.heading }}
  </p>
  <div class="complete-your-transfer-banner__button-wrapper">
    <c11n-button
      [labelText]="content.buttonLabel"
      iconName="link-right"
      iconPosition="trailing"
      data-cy="get-started-button"
      (clickEvent)="onGetStarted()"
    ></c11n-button>
  </div>
</div>
